export default String.raw`
.wishlist-popup.dialog.middle {
    width: 520px;
}
`